import { type FC } from 'react';

import { Link } from '../../../Link';

interface ICianMortgageTextProps {
  cianMortgageUrl: string;
}

export const CianMortgageText: FC<ICianMortgageTextProps> = ({ cianMortgageUrl }) => {
  const cianMortgageLinkElement = (
    <Link target="blank" url={cianMortgageUrl}>
      Циан.Ипотеки
    </Link>
  );

  return <span>Воспользуйтесь предложениями от {cianMortgageLinkElement}</span>;
};
